import {Country} from "../country/country"
import {Type} from "class-transformer"

export class ShipmentSender {
  @Type(() => Country)
  country: Country
  company: string
  office: string
  username: string
  street1: string
  houseNumber: string
  street2: string
  city: string
  postalCode: string
  phone: string
  mobile: string
  email: string
  reference: string
  comment: string

  constructor(
    username: string,
    office: string,
    company: string,
    country: Country,
    street1: string,
    houseNumber: string,
    street2: string,
    city: string,
    postalCode: string,
    phone: string,
    mobile: string,
    email: string,
    reference: string,
    comment: string
  ) {
    this.username = username
    this.office = office
    this.company = company
    this.country = country
    this.street1 = street1
    this.houseNumber = houseNumber
    this.street2 = street2
    this.city = city
    this.postalCode = postalCode
    this.phone = phone
    this.mobile = mobile
    this.email = email
    this.reference = reference
    this.comment = comment
  }
}
